import React from 'react';
import style from './index.module.scss';


export default class CombinedLabel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: '',
        };
    }

    componentDidMount() {
        this.updateValue(this.props);
    }

    componentDidUpdate(prevProps) {
        /**
         * ⚠️ 不要用 JSON.stringify（会导致更新丢失或性能问题）
         * FormRender 的 formData / getValue 才是关键
         */
        if (
            prevProps.addons?.formData !== this.props.addons?.formData ||
            prevProps.combine_elements !== this.props.combine_elements
        ) {
            this.updateValue(this.props);
        }
    }

    updateValue = (props) => {
        const combine_elements = props?.combine_elements ?? [];

        const addons = props?.addons;

        const value = combine_elements
            .map((item) => {
                const { type } = item;

                /**
                 * 静态文本
                 */
                if (type === 'static') {
                    return item.value ?? '';
                }

                /**
                 * 表单字段
                 */
                if (type === 'key') {
                    let v = addons?.getValue?.(item.value);

                    // 兜底：避免 undefined
                    if (v === undefined || v === null) {
                        v = '';
                    }

                    if (item.value === 'day' && typeof v === 'string') {
                        v = v.replaceAll('-', '');
                    }

                    return v;
                }

                return '';
            })
            .join('');

        /**
         * 更新 state（驱动 UI）
         */
        if (value !== this.state.value) {
            this.setState({
                value,
            });
        }
        if (props.onChange && value !== props.value) {
            props.onChange(value);
        }
    };

    render() {
        return (
            <div className={style.wrapper}>
                {this.state.value ?? ''}
            </div>
        );
    }
}